// extracted by mini-css-extract-plugin
export default {"price":"z7-z","priceRow":"A7-z","onSale":"B7-z","msrpLabelPrice":"C7-z","msrpLabel":"D7-z","originalPrice":"E7-z","percentOff":"F7-z"};